<template>
	<!-- 通过isNeedUplaodContract处理未上传附件时的情况
	然后通过contractInfo处理已上传后的情况 -->
  <div class="mobile_main" v-if="isNeedUplaodContract || (contractInfo && contractInfo.pdf_hash)">
		<!-- Trigger -->
		<button id="copyBox" ref='copyBox' :data-clipboard-text="pdfUrl" hidden>
				Copy to clipboard
		</button>
		<div class="contract" id="pdfDom">
			<div class="ql-container ql-snow">
				<div class="ql-editor">
					<div class="contract_body" v-html="content"></div>
				</div>
			</div>
		</div>

		<div class="bottom_design">
			<!-- 甲乙双方都没签名时显示 -->
			<div class="client_box" v-if="contractInfo && (contractInfo.status === contractSignatureTypeMap.unSign || contractInfo.status === contractSignatureTypeMap.unPass)">
				<!-- 供应商签名后，顾客才能签名的限制 -->
				<div class="item" v-if="signAll && !signAll.supplier" @click="toDesignPage(userTypeMap.company)">甲方{{signAll && !signAll.supplier ? '待' : '已'}}签名</div>
				<div class="item gray_color" v-else >甲方{{signAll && !signAll.supplier ? '待' : '已'}}签名</div>
				<div class="split"></div>
				<!-- 乙方需等甲方签名后，才能签名 -->
				<div class="item" v-if="signAll && signAll.supplier && !signAll.customer" @click.stop="toDesignPage(userTypeMap.user)">
					乙方{{signAll && signAll.supplier && !signAll.customer ? '待' : '已'}}签名
					<span class="notyfy" v-if="isCanNotifyUser" @click.stop.self="notifyUser">客人已离开，通知客人签字</span>
					<span class="notyfy gray_color" v-else  @click.stop.self="">已通知客人，待签字</span>
				</div>
				<div class="item gray_color" v-else>
					乙方{{signAll && !signAll.customer ? '待' : '已'}}签名
				</div>
			</div>
			<!-- 双方都签了名，并且上传了合同附件 -->
			<div class="driver" v-if="signAll && signAll.customer && signAll.supplier" @click="getContractPdf">下载保存</div>
		</div>
		<GeneraterContent
			:order_id="order_id"
			:company_id="company_id"
			:is_need_sign="signAll && !!(signAll.customer || signAll.supplier)"
			@error="onGeneraterContentError"
			@templateData="onGeneraterContentSuccess"
			@formData="onGeneraterFormDataSuccess"
			v-if="company_id && order_id && isMobile"
		/>
  </div>
</template>

<script>
import request from '@/utils/request';
import GeneraterContent from '@components/generater_content';
import Clipboard from 'clipboard';
import { exitApp, onStatisticsEvent } from '@/utils/native';

function _isMobile() {
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	return flag;
}

/**
 * 车行还是顾客
 */
const userTypeMap = {
	company: '00',
	user: '01',
}

/**
 * 签名客户端
 */
const signClientTypeMap = {
	ercp: 'ercp',
	zzc: 'zzc',
	rce: 'rce',
}

// 状态，0-待签名，1-待审核，2-通过，3-不通过
const contractSignatureTypeMap = {
	unSign: 0,
	unAudit: 1,
	pass: 2,
	unPass: 3,
};

export default {
	name: 'leaseContract.mobile',
  components: {
		GeneraterContent,
	},
  data() {
    return {
      loading: false,
      content: '',
      editorOption: {
        placeholder: '暂无电子合同',
        modules: {
          toolbar: false,
        },
      },
      cust_full_name: '',
      company_name: '',
      driver_token: '',
			companyName: '',
			userName: '',
			isMobile: false,
			userTypeMap,
			order_id: '',
			company_id: '',
			signAll: null,
			isCanNotifyUser: false, // 是否可通知用户
			contractSignatureTypeMap,
			contractInfo: null,
			isNeedUplaodContract: false,
			pdfUrl: '12341234',
    };
  },
  computed: {},
	created() {
		this.isNeedUplaodContract = false;
	},
  async mounted() {
		var clipboard = new Clipboard("#copyBox");
		clipboard.on("success", function (element) {//复制成功的回调
		　　console.info("复制成功，复制内容： " + element.text);
		});
		clipboard.on("error",function (element) {//复制失败的回调
		　　console.info(element);
		});

		const that = this;
		console.log('解析路径', this.$route.query);
		const {
			order_id,
			company_id,
			sign_client,
		} = this.$route.query;
		if (!order_id) {
      this.$message({
        type: 'error',
        message: '没有获取到订单号',
      });
      return;
    }
    if (!company_id) {
      this.$message({
        type: 'error',
        message: '没有获取到公司ID',
      });
    }

		if (sign_client === 'rce') {
			onStatisticsEvent("page", "在线合同");
		}
		this.isMobile = _isMobile() && !!_isMobile().length;
		console.log('this.isMobile', this.isMobile);
		if (!this.isMobile) {
			this.$alert('请使用移动端设备打开该链接，感谢支持', '提示', {
				confirmButtonText: '确定',
			});
			return;
		}
		this.order_id = order_id;
    this.company_id = company_id;
		this.contractInfo = null; // 合同信息情况
		await this.getContractInfo();
		that.checkNotifyUser();
		const isSignatureAll = await this.getSignatureAll();
		const isNeedUplaodContract = await this.checkHasUploadFile();
		this.isNeedUplaodContract = isNeedUplaodContract;
		// 没签名和已上传，则为app上传了附件
		if (!isSignatureAll && !isNeedUplaodContract) {
			// 报弹窗提示
			this.$confirm(`检测到车行已上传纸质租车合同，电子合同将无法签订并关闭`, '提示', {
				confirmButtonText: '确定',
				customClass: 'confirm_box_width_change',
				type: 'warning',
				showCancelButton: false,
				showClose: false,
				closeOnClickModal: false,
				closeOnPressEscape: false,
				callback: action => {
					if (action === 'confirm') {
						return;
					}
					console.log('没签名和已上传，则为app上传了附件 operate', action);
				}
			});
		}
		// this.$nextTick(() => {
		// 	document.addEventListener('visibilitychange', this.onShowFn);
		// })
  },
	beforeDestroy() {
		document.removeEventListener('visibilitychange', this.onShowFn);
	},
  methods: {
		// 跳转签名页
		toDesignPage(key) {
			const {
				order_id,
				company_id,
				sign_client,
			} = this.$route.query;
			// if (key === userTypeMap.user) {
			// 	this.$message({
      //     message: '请等待甲方签名后，乙方才可以签名',
      //     type: 'warning'
      //   });
			// 	return
			// }
			const data = {
				user_type: key,
				order_id,
				company_id,
			}
			console.log('toDesignPage sign_client ', sign_client)
			if (sign_client === 'rce') {
				data.ZZCAppArg = 'topBar_Hidden,topBar_Remove'
			}
			this.$router.push({
				name: 'leaseContract.design',
				query: data,
			});
		},
		onGeneraterContentError(err) {
			console.log('onGeneraterContentError err', err);
			this.$message({
				type: "error",
				message: err.msg || err.message,
			});
		},
		onGeneraterContentSuccess(data) {
			console.log('onGeneraterContentSuccess')
			this.content = data;
		},
		onGeneraterFormDataSuccess(data) {
			console.log('onGeneraterFormDataSuccess', data);
			this.formData = data;
		},
		// async onGeneraterImageSuccess(data) {
		// 	const { src } = data;
		// 	const contractHash = await this.uploadImage(src);
		// 	if (!contractHash) {
		// 		return;
		// 	}
		// 	this.isNeedContractImage = false;
		// 	await this.uploadContract(contractHash);
		// 	this.$message({
		// 		type: "success",
		// 		message: "上传成功",
		// 		duration: 10 * 1000
		// 	});
		// 	await	this.getContractInfo()
		// },
		// uploadImage(imageBase64) {
		// 	let that = this;
		// 	console.log("uploadImage");
		// 	return request({
		// 		url: "/Api/other/uploadImageByBase64",
		// 		method: "POST",
		// 		data: {
		// 			type: "base64",
		// 			image: imageBase64
		// 		}
		// 	})
		// 		.then(res => {
		// 			if (res.code != 0) {
		// 				that.$message({
		// 					type: "error",
		// 					message: res.msg || res.message
		// 				});
		// 				return null;
		// 			}
		// 			return res.data.hash;
		// 		})
		// 		.catch(err => {
		// 			that.$message({
		// 				type: "error",
		// 				message: err.msg || err.message
		// 			});
		// 		});
		// },
		// // 上传合同
		// uploadContract(hash) {
		// 	let that = this;
		// 	console.log("uploadImage");
		// 	const {
		// 	  order_id, company_id,
		// 	} = this.$route.query;
		// 	return request({
		// 		url: "/Api/contract/setContractInfo",
		// 		method: "POST",
		// 		data: {
		// 			order_id,
		// 			company_id,
		// 			hash,
		// 			user: {
		// 				user_id: 0,
		// 				user_name: 'system',
		// 				source: "main_common_web", // APPLICATION
		// 			}
		// 		}
		// 	})
		// 		.then(res => {
		// 			if (res.code != 0) {
		// 				that.$message({
		// 					type: "error",
		// 					message: res.msg || res.message
		// 				});
		// 				return null;
		// 			}
		// 			const { up } = res.data;
		// 			if (up) {
		// 				console.log("上传成功", res);
		// 			}
		// 			// that.back();
		// 		})
		// 		.catch(err => {
		// 			that.$message({
		// 				type: "error",
		// 				message: err.msg || err.message
		// 			});
		// 		});
		// },
		// 获取合同情况
		getContractInfo() {
			let that = this;
			const { order_id, company_id } = this.$route.query;
			return request({
				url: "/Api/contract/getContractInfo",
				method: "POST",
				data: {
					order_id,
					company_id,
				}
			})
				.then(res => {
					if (res.code != 0) {
						that.$message({
							type: "error",
							message: res.msg || res.message
						});
						return null;
					}
					that.contractInfo = res.data;
					return that.contractInfo;
				})
				.catch(err => {
					that.$message({
						type: "error",
						message: err.msg || err.message
					});
				});
		},
		// 获取双方签名情况
		getSignatureAll() {
			let that = this;
			const { order_id, company_id } = this.$route.query;
			return request({
				url: "/Api/contract/getSignatureAll",
				method: "POST",
				data: {
					order_id,
					company_id,
				}
			})
				.then(res => {
					if (res.code != 0) {
						that.$message({
							type: "error",
							message: res.msg || res.message
						});
						return null;
					}
					that.signAll = res.data;
					const { supplier, customer } = res.data;
					return supplier && customer;
				})
				.catch(err => {
					that.$message({
						type: "error",
						message: err.msg || err.message
					});
				});
		},
		// 获取上传附件：查看是否已经上传了电子合同附件，APP端可以上传
		checkHasUploadFile() {
			let that = this;
			const {
			  order_id, company_id,
			} = this.$route.query;
			return request({
				url: "/Api/contract/checkHasUploadFile",
				method: "POST",
				data: {
					order_id,
					company_id,
					cid: 7,
					user: {
						// 租车通需要 user_id、user_name
						user_id: 0,
						user_name: 'system',
						source: "main_common_web", // APPLICATION
					}
				}
			})
				.then(res => {
					if (res.code != 0) {
						that.$message({
							type: "error",
							message: res.msg || res.message
						});
						return null;
					}
					const { list } = res.data;
					// console.log('checkHasUploadFile list', list);
					return !list.length;
				})
				.catch(err => {
					that.$message({
						type: "error",
						message: err.msg || err.message
					});
				});
		},
		getContractPdf() {
			let that = this;
			const { order_id, company_id, sign_client } = this.$route.query;
			if (!that.formData) {
				that.$message({
					type: "error",
					message: "接口报错导致缺少参数"
				});
			}
			request({
				url: "/Api/contract/getContractPdf",
				method: "POST",
				data: {
					order_id,
					company_id,
					companyName: that.formData.companyName,
					userName: that.formData.userName,
					hash: that.contractInfo.pdf_hash,
				},
			})
				.then(({ res }) => {
					console.log('res.data', res.data);

					if (res.data.code != 0) {
						return;
					}
					const url = res.data.data.url;
					console.log('url', url)
					if (sign_client === 'rce') {
						window.flutter_inappwebview.callHandler(
							"openSystemBrowser",
							{ url }
						);
					} else {
						that.pdfUrl = url;
						const a = document.createElement("a");
						a.href = url;
						// a.target = '_blank';
						document.body.appendChild(a);
						a.click();
						a.remove();
						that.$confirm(`如下载失败，请复制链接到其他浏览器打开重新下载`, '提示', {
							customClass: 'confirm_box_width_change',
							confirmButtonText: '复制',
							type: 'warning',
							showCancelButton: true,
							showClose: false,
							closeOnClickModal: false,
							closeOnPressEscape: false,
							callback: action => {
								if (action === 'confirm') {
									// 复制内容
									that.$refs.copyBox.click();
								}
								console.log('如下载失败，请复制链接到其他浏览器打开重新下载 operate', action);
							}
						});
					}
				})
				.catch(err => {
					console.log("err", err);
					that.$message({
						type: "error",
						message: err.msg || err.message
					});
				});
		},
		// 通知用户签名
		notifyUser() {
			let that = this;
			console.log("notifyUser");
			const { order_id, company_id } = this.$route.query;
			return request({
				url: "/Api/contract/notifyUser",
				method: "POST",
				data: {
					order_id,
					company_id,
					order_signature_id: that.contractInfo.id,
					user: {
						// 租车通需要 user_id、user_name
						user_id: 0,
						user_name: 'system',
						source: "main_common_web", // APPLICATION
					}
				}
			})
				.then(res => {
					if (res.code != 0) {
						that.$message({
							type: "error",
							message: res.msg || res.message
						});
						return null;
					}
					const { up } = res.data;
					if (up) {
						that.checkNotifyUser();
						that.$message({
							type: "success",
							message: "通知成功",
							duration: 10 * 1000
						});
						console.log("通知成功", res);
						// 查询最新的通知情况
					}
					// that.back();
				})
				.catch(err => {
					that.$message({
						type: "error",
						message: err.msg || err.message
					});
				});
		},
		// 核对是否已经通知过用户
		checkNotifyUser() {
			let that = this;
			console.log("checkNotifyUser");
			const { order_id, company_id } = this.$route.query;
			return request({
				url: "/Api/contract/checkNotifyUser",
				method: "POST",
				data: {
					order_id,
					company_id,
					order_signature_id: that.contractInfo.id,
					user: {
						// 租车通需要 user_id、user_name
						user_id: 0,
						user_name: 'system',
						source: "main_common_web", // APPLICATION
					}
				}
			})
				.then(res => {
					if (res.code != 0) {
						that.$message({
							type: "error",
							message: res.msg || res.message
						});
						return null;
					}
					const { check } = res.data;
					that.isCanNotifyUser = check;
				})
				.catch(err => {
					that.$message({
						type: "error",
						message: err.msg || err.message
					});
				});
		},
		onShowFn() {
			const that = this;
			this.getContractInfo()
			.then(() => {
				that.getSignatureAll();
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.mobile_main {
	background-color: #fff;
}
.ql-container.ql-snow  {
	border: none;
}
.contract_body .ql-align-justify {
	padding: 0!important;
	margin: 0!important;
}
.contract_body {
  text-align: left;
  padding: 0.75rem 0.75rem 11.5rem 0.75rem;
}
.voucher_tips {
	// display: none;
	bottom: auto;
	position: fixed;
	top: 0;
	padding: 1rem;
	right: 0;
	width: 7.5rem;
	.box {
		width: 7.4rem;
		height: auto;
		background-color: #fff;
		border: 0.05rem solid #bbb;
		.title {
			background-color: #f1f1f1;
			border-bottom: 0.05rem solid #e5e5e5;
			color: #aaa;
			margin-bottom: 0.5rem;
			padding: 0.5rem;
		}
		.btn_row {
			.btn {
				width: 6.4rem;
				margin: 0rem auto 0.5rem;
				border: 0.05rem solid #dcdcdc;
				.icon {
					margin-right: 0.25rem;
				}
				.icon_pdf {
					background-image: url("http://static.zuzuche.com/assets/ercp/app/apk/pdf_icon.png");
					width: 0.8rem;
					height: 0.8rem;
					display: inline-block;
					background-size: contain;
					background-repeat: no-repeat;
					margin-bottom: -0.1rem;
				}
				.print {
					background-color: #ffd14c;
				}
				a {
					cursor: pointer;
					color: #582f0c;
					display: block;
					font-size: 0.7rem;
					font-weight: 700;
					height: 1.75rem;
					line-height: 1.75rem;
					text-decoration: none;
				}
			}
		}
	}
}

.voucher_tips_box {
	　　display: block;
}
p {
  margin: 0;
}
.bottom_design {
	position: fixed;
	bottom: 0;
	width: 100%;
	padding: 0 0.5rem 2rem 0.5rem;
	box-sizing: border-box;
	text-align: center;
	background-color: #fff;
	font-size: 0.8rem;
	.client_box {
		display: flex;
		align-items: center;
		height: 2.5rem;
		line-height: 2.5rem;
		.item {
			position: relative;
			flex-grow: 1;
			background-color: rgb(0, 157, 216);
			color: #fff;
			border-radius: 0.25rem;
			cursor: pointer;
			&.gray_color {
				background-color: rgb(121, 121, 121);
			}
			.notyfy {
				position: absolute;
				bottom: -1.5rem;
				left: 0;
				right: 0;
				font-size: 0.6rem;
				height: 1.5rem;
				line-height: 1.5rem;
				color: #009dd8;
				text-decoration: underline;
				&.gray_color {
					color: rgb(121, 121, 121);
				}
			}
		}
		.split {
			width: 2rem;
		}
	}
	.driver {
		margin: 0.25rem 1rem 0 1rem;
		height: 2rem;
		line-height: 2rem;
		background-color: blue;
		color: #fff;
		border-radius: 0.25rem;
		cursor: pointer;
	}

}
</style>
<style>
.el-message-box.confirm_box_width_change {
	width: 80%;
}
</style>